import { TypedGlNode } from "./_Base";
import { GlConnectionPointType } from "../utils/io/connections/Gl";
export const ATTRIBUTE_NODE_AVAILABLE_GL_TYPES = [
  GlConnectionPointType.FLOAT,
  GlConnectionPointType.VEC2,
  GlConnectionPointType.VEC3,
  GlConnectionPointType.VEC4
];
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { GlNodeType } from "../../poly/NodeContext";
import { isBooleanTrue } from "../../../core/BooleanValue";
class AttributeGlParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.name = ParamConfig.STRING("attribute1");
    this.type = ParamConfig.INTEGER(0, {
      menu: {
        entries: ATTRIBUTE_NODE_AVAILABLE_GL_TYPES.map((name, i) => {
          return { name, value: i };
        })
      }
    });
    this.texportWhenConnected = ParamConfig.BOOLEAN(0, { hidden: true });
    this.exportWhenConnected = ParamConfig.BOOLEAN(0, { visibleIf: { texportWhenConnected: 1 } });
  }
}
const ParamsConfig = new AttributeGlParamsConfig();
const _AttributeGlNode = class extends TypedGlNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
    this._bound_setExportWhenConnectedStatus = this._setExportWhenConnectedStatus.bind(this);
  }
  static type() {
    return GlNodeType.ATTRIBUTE;
  }
  initializeNode() {
    this.addPostDirtyHook("_setMatToRecompile", this._setMatToRecompileIfIsExporting.bind(this));
    this.io.connection_points.initializeNode();
    this.io.connection_points.set_expected_input_types_function(() => {
      var _a, _b;
      if ((_b = (_a = this.materialNode()) == null ? void 0 : _a.assemblerController()) == null ? void 0 : _b.allow_attribute_exports()) {
        return [ATTRIBUTE_NODE_AVAILABLE_GL_TYPES[this.pv.type]];
      } else {
        return [];
      }
    });
    this.io.connection_points.set_input_name_function((index) => {
      return _AttributeGlNode.INPUT_NAME;
    });
    this.io.connection_points.set_expected_output_types_function(() => [
      ATTRIBUTE_NODE_AVAILABLE_GL_TYPES[this.pv.type]
    ]);
    this.lifecycle.onAfterAdded(this._bound_setExportWhenConnectedStatus);
    this.params.addOnSceneLoadHook("prepare params", this._bound_setExportWhenConnectedStatus);
  }
  _setExportWhenConnectedStatus() {
    var _a, _b;
    if ((_b = (_a = this.materialNode()) == null ? void 0 : _a.assemblerController()) == null ? void 0 : _b.allow_attribute_exports()) {
      this.p.texportWhenConnected.set(1);
    }
  }
  setAttribSize(size) {
    this.p.type.set(size - 1);
  }
  inputName() {
    return _AttributeGlNode.INPUT_NAME;
  }
  outputName() {
    return _AttributeGlNode.OUTPUT_NAME;
  }
  varyingName() {
    return `v_POLY_attribute_${this.pv.name}`;
  }
  setLines(shadersCollectionController) {
    const assembler = shadersCollectionController.assembler();
    assembler.setNodeLinesAttribute(this, shadersCollectionController);
  }
  attributeName() {
    return this.pv.name.trim();
  }
  glType() {
    return this.io.outputs.namedOutputConnectionPoints()[0].type();
  }
  setGlType(type) {
    this.p.type.set(ATTRIBUTE_NODE_AVAILABLE_GL_TYPES.indexOf(type));
  }
  connected_input_node() {
    return this.io.inputs.named_input(_AttributeGlNode.INPUT_NAME);
  }
  connected_input_connection_point() {
    return this.io.inputs.named_input_connection_point(_AttributeGlNode.INPUT_NAME);
  }
  output_connection_point() {
    return this.io.outputs.namedOutputConnectionPointsByName(this.outputName());
  }
  isImporting() {
    return this.io.outputs.used_output_names().length > 0;
  }
  isExporting() {
    if (isBooleanTrue(this.pv.exportWhenConnected)) {
      const input_node = this.io.inputs.named_input(_AttributeGlNode.INPUT_NAME);
      return input_node != null;
    } else {
      return false;
    }
  }
  _setMatToRecompileIfIsExporting() {
    if (isBooleanTrue(this.pv.exportWhenConnected)) {
      this._setMatToRecompile();
    }
  }
};
export let AttributeGlNode = _AttributeGlNode;
AttributeGlNode.INPUT_NAME = "in";
AttributeGlNode.OUTPUT_NAME = "val";
